export default __webpack_public_path__ + "static/media/broken-link-gif.8fddace7.gif";